export default __webpack_public_path__ + "static/AmericanInstituteOfLegalAdvocates-d87d154955c243cfc0937c1ce2589591.png";